import { render, staticRenderFns } from "./TakerServiceTab.vue?vue&type=template&id=e53646ec&scoped=true&"
import script from "./TakerServiceTab.vue?vue&type=script&lang=js&"
export * from "./TakerServiceTab.vue?vue&type=script&lang=js&"
import style0 from "./TakerServiceTab.vue?vue&type=style&index=0&id=e53646ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53646ec",
  null
  
)

export default component.exports